/**
 * ATL-953 — form-field coercions for product screens, where `null` and `0` are different answers.
 *
 * The read transform used to substitute `0` for a NULL `stock_threshold` (and for a NULL purchase
 * or package price), which manufactured a `compare-spotcheck` disagreement against Firestore's
 * `null`. It no longer does — so every consumer that treated "absent" as "zero" has to say what it
 * means.
 */

/**
 * The string a threshold input should start with.
 *
 * ⚠️ NOT `isNaN(value) ? '1' : value.toString()`, which is what both call sites did. `Number(null)`
 * is `0`, so `isNaN(null)` is **false** — the expression then calls `.toString()` on `null` and
 * throws while opening a product. `Number.isFinite` asks the question that was meant.
 *
 * `0` is a real threshold and is preserved. A numeric string is accepted because both stores have
 * been seen to hold one.
 *
 * @param {unknown} value
 * @returns {string}
 */
export const stockThresholdInputValue = (value) => {
  const numeric = typeof value === 'string' && value.trim() !== '' ? Number(value) : value
  return typeof numeric === 'number' && Number.isFinite(numeric) ? String(numeric) : '1'
}

export default { stockThresholdInputValue }
